import React from "react";
import styles from "./CollectionYardVisitEventItem.module.scss";
import { CollectionYardVisitEvent } from "../../../types/collectionYards";
import { formatCurrency } from "../../../utils/currency";
import { formatWeight } from "../../../utils/weight";
import { useTranslation } from "react-i18next";

type CollectionYardVisitProps = {
  event: CollectionYardVisitEvent;
};

export const CollectionYardVisitEventItem: React.FC<CollectionYardVisitProps> = ({ event }) => {
  const { eventId, wasteType, wasteSum, priceSum, unitPrice } = event;
  const { t } = useTranslation();

  return (
    <div className={styles.item} key={eventId}>
      <div className={styles.itemContent}>
        <h6 className={styles.itemTitle}>
          <div>{t(`enums.allWasteTypes.${wasteType}`)}</div>
        </h6>
        <div className={styles.wasteTypes}>
          <span>{formatWeight(wasteSum)}</span>
          <span className={styles.divider} />
          <span>{formatCurrency(unitPrice)}</span>
        </div>
      </div>
      <div className={styles.itemActions}>
        <span>{formatCurrency(priceSum)}</span>
      </div>
    </div>
  );
};
